"use strict";

const InspectionPreview = function () {
  var preview = async function (dataFn, endpointFn) {
    const preview = new PreviewDownloader();
    const data = await dataFn();
    data.previewImages = true;

    convertToPreviews(data);

    let pdfBinary;
    try {
      pdfBinary = await endpointFn(Form.toFormData(data));
    } catch (e) {
      preview.showMessage(
        "Failed to generate preview, please try again later or <a href='https://kb.2ndnaturewater.com/knowledge/kb-tickets/new' target='_blank'>contact support</a> for assistance.",
      );
      throw e;
    }

    preview.openBlob(new Blob([pdfBinary], { type: "application/pdf" }));

    return data;
  };

  var convertToPreviews = function (data) {
    Misc.eachNestedProperty(data, function (value, key, parent) {
      if (key === "photos" && value) {
        for (const photo of value) {
          try {
            delete photo.file;
            photo.preview = true;
          } catch (e) {
            console.error("Invalid photo, skipping:", photo);
          }
        }
        return true;
      }

      if (value instanceof File) {
        parent[key] = { name: value.name };
        return true;
      }

      if (value instanceof Blob) {
        delete parent[key];
        return true;
      }
    });

    return data;
  };

  return {
    preview,
    convertToPreviews,
  };
};

module.exports = InspectionPreview();

const Form = require("../general/form");
const Misc = require("../misc");
const PreviewDownloader = require("../files/previewDownloader");
